const state = {
  question: {},
  answer:{}
}

export default state



// WEBPACK FOOTER //
// ./src/store/modules/raceQuestion/state.js